import assets from '@/assets';

export default {
  name: 'pic',
  props: {
    name: {
      type: String,
      required: true,
    },
    ext: {
      type: String,
      default: 'png',
    },
    w: {
      type: String,
    },
    h: {
      type: String,
    },
  },
  computed: {
    src: ({ name, ext }) => assets[`${name}.${ext}`],
    style: ({ w, h }) => ({ height: h, width: w }),
  },
};



// WEBPACK FOOTER //
// ./src/comp/Pic/_.js